/* ------------------------------------------------------------------ */
/* Pricing accent palette                                             */
/* Mirrors the "Banquet First" red brand accent used across the v2    */
/* business-onboarding screens so the pricing page matches it.        */
/* Kept as a local copy (not an import) so the pricing views do not    */
/* depend on the authentication/onboarding module.                     */
/* ------------------------------------------------------------------ */
export const PRICING_ACCENT = {
  main: "#b4314a",
  dark: "#95293d",
  soft: "#f7e6ea",
  ring: "#b4314a",
};
